@if (this.template(); as template) {
  <ng-template
    [ngTemplateOutlet]="template"
    [ngTemplateOutletContext]="{ event: this.modalState()?.input()?.event, preset: this.modalState()?.input()?.preset }"
  ></ng-template>
} @else {
  No template provided.
}
